<template>
  <div
    v-if="showed"
    v-loading.fullscreen.lock="fullScreenLoading"
    @click="pay"
    :class="{
      'disabled-payment': disabled,
    }"
    class="noda-payment-button"
  >
    <div>
      <img
        src="@/assets/img/icons/visa.png"
        width="33px"
        height="22px"
        alt="Visa"
        style="margin-right: 8px"
      >
      <img
        src="@/assets/img/icons/mastercard.png"
        width="33px"
        height="22px"
        alt="Mastercard"
      >
    </div>
  </div>
</template>

<script>
import nodaMixin from "./noda-mixin";
import paymentMixin from "../payment-mixin";

export default {
  name: "NodaCreditCard",
  mixins: [nodaMixin, paymentMixin],
};
</script>

<style lang="scss" scoped src="./noda-button.scss"></style>
